import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import FacebookIcon from "../../atoms/social-media-icons/Facebook";
import InstagramIcon from "../../atoms/social-media-icons/Instagram";
import TwitterShareIcon from "../../atoms/social-media-icons/Twitter";
import YoutubeIcon from "../../atoms/social-media-icons/Youtube";
import TelegramIcon from "../../atoms/social-media-icons/Telegram";
import WhatsAppIcon from "../../atoms/social-media-icons/Whatsapp";

import "./social-share.m.css";

const SocialShareIcons = ({ socialLinks, socials }) => {
  if (!socialLinks) {
    return null;
  }

  const WHATSAPP_URL = "https://www.whatsapp.com/channel/0029Va4ifN6AYlULZASc7V3S";
  const list = [
    {
      Type: (
        <div styleName="icon-wrapper">
          <WhatsAppIcon color="white" height="14" width="14" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.whatsapp ? socials.whatsapp.url : WHATSAPP_URL,
      name: "Whatsapp"
    },
    {
      Type: (
        <div styleName="icon-wrapper">
          <FacebookIcon color="white" height="14" width="14" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.facebook ? socials.facebook.url : socialLinks["facebook-url"],
      name: "Facebook"
    },
    {
      Type: (
        <div styleName="icon-wrapper">
          <TwitterShareIcon color="white" height="14" width="14" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.twitter ? socials.twitter.url : socialLinks["twitter-url"],
      name: "Twitter"
    },
    {
      Type: (
        <div styleName="icon-wrapper">
          <InstagramIcon color="white" height="14" width="14" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.instagram ? socials.instagram.url : socialLinks["instagram-url"],
      name: "Instagram"
    },
    {
      Type: (
        <div styleName="icon-wrapper">
          <YoutubeIcon color="white" height="14" width="14" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.youtube ? socials.youtube.url : socialLinks["youtube-url"],
      name: "Youtube"
    },

    {
      Type: (
        <div styleName="icon-wrapper">
          <TelegramIcon color="white" height="14" width="14" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.telegram ? socials.telegram.url : socialLinks["telegram-url"],
      name: "Telegram"
    }
  ];

  return (
    <div styleName="wrapper" className="social-icons-wrapper">
      {list.map(({ url, Type, name }, index) => (
        <a
          href={url}
          key={index}
          styleName="social-link-item"
          className="social-link-item"
          target="_blank"
          rel="nofollow noreferrer"
          style={list.length === index + 1 ? {marginRight: "0px"} : {}}
        >
          {Type}
        </a>
      ))}
    </div>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps, null)(SocialShareIcons);
